
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import { useVisibilityChange } from "@uidotdev/usehooks";
import logo from "../../assets/cbe_logo.jpg";
import { useHistory } from "react-router-dom";
import Cookie from "js-cookie";
// import { AlertTriangle, Shield, Lock } from "lucide-react"


const signinSchema = Yup.object().shape({
  identifier: Yup.string()
    .required("Email is required")
    .email("Invalid email format")
    .max(40, "Email cannot be longer than 40 characters"),
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters")
    .max(15, "Password cannot be longer than 15 characters"),
});

function Signin() {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(signinSchema) });

  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");

  const SESSION_TIMEOUT_DURATION = 60000; // 1 minute in milliseconds
  let inactivityTimer;
  const documentVisible = useVisibilityChange();

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    localStorage.removeItem("username");
    Cookie.remove("loggedIn");
    history.push("/signin");
  };

  useEffect(() => {
    if (!documentVisible) {
      inactivityTimer = setTimeout(() => {
        // console.log("Session timed out due to inactivity");
        handleLogout();
      }, SESSION_TIMEOUT_DURATION);
    } else {
      clearTimeout(inactivityTimer);
    }

    return () => clearTimeout(inactivityTimer);
  }, [documentVisible]);

  const onSubmit = async (data) => {
    setLoading(true);
    setLoginError("");

    try {
      // At the top of your file
const API_BASE = process.env.REACT_APP_API_URL ;

// In your login function
const res = await axios.post(`${API_BASE}/auth/local`, data

      // const res = await axios.post('https://see.cbe.com.et/api/auth/local',data
        // `${process.env.REACT_APP_API_URL}/auth/local`,        data
      );
      if (res.data && res.data.jwt) {
        localStorage.setItem("token", res.data.jwt);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        localStorage.setItem("username", res.data.user.username);
        localStorage.setItem("canSeePassport", res.data.user.canSeePassport);

      // Store passport types if the user can see passport
      if (res.data.user.canSeePassport) {
        localStorage.setItem("passportTypes", JSON.stringify(res.data.user.passport_types));
      }
        Cookie.set("loggedIn", "true", { expires: 15 /1440 });

        history.push("/faq");
      } else {
        setLoginError("Invalid email or password.");
      }
    } catch (error) {
      setLoginError("Invalid email or password.");
    }

    setLoading(false);
  };

  return (
    <div>
      <section className="h-screen">
        <div className="h-full px-6 text-gray-800">
          <div className="flex flex-wrap items-center justify-center h-full xl:justify-center lg:justify-between g-6">
            <div className="mb-12 grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 md:mb-0">
              <img src={logo} className="w-full" alt="cbe logo" />
            </div>
         
            <div className="mb-12 xl:ml-20 xl:w-5/12 lg:w-5/12 md:w-8/12 md:mb-0">
            <div className="min-h-screen bg-white flex items-center justify-center p-8">
      <div className="w-full max-w-4xl border-2 border-red-200 shadow-2xl rounded-lg bg-white">
        <div className="text-center space-y-4 pb-6 p-6">
          <div className="flex justify-center">
            <div className="bg-red-100 p-4 rounded-full">
              {/* <AlertTriangle className="h-12 w-12 text-red-600" /> */}
            </div>
          </div>
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-red-800">SYSTEM ACCESS WARNING</h1>
            <div className="flex items-center justify-center gap-2 text-green-700">
              {/* <Shield className="h-5 w-5" /> */}
              <span className="font-semibold">Commercial Bank of Ethiopia (CBE)</span>
            </div>
          </div>
        </div>

        <div className="space-y-6 p-6">
          <div className="border border-amber-200 bg-amber-50 p-4 rounded-md flex items-start gap-3">
            {/* <Lock className="h-4 w-4 text-amber-600 mt-0.5 flex-shrink-0" /> */}
            <div className="text-amber-800 font-medium">
              NOTICE: You are about to access Commercial Bank of Ethiopia (CBE) user access service and you
              should have appropriate authorization from concerned authority before using these service. Use of CBE
              provided information systems and networks in violation of company guidelines will result in disciplinary
              action, up to and including prosecution.
            </div>
          </div>

          <div className="text-center text-xs text-gray-500 pt-2 border-t">
            Commercial Bank of Ethiopia - Information Security Notice
          </div>
        </div>
      </div>
    </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-6">
                  <input
                    type="text"
                    {...register("identifier")}
                    placeholder="Email"
                    style={{
                      width: "100%",
                      padding: "10px",
                      margin: "6px 0",
                      display: "inline-block",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxSizing: "border-box",
                      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  {errors.identifier && (
                    <p style={{ color: "red" }}>{errors.identifier.message}</p>
                  )}
                </div>

                <div className="mb-6">
                  <input
                    type="password"
                    {...register("password")}
                    placeholder="Password"
                    style={{
                      width: "100%",
                      padding: "10px",
                      margin: "6px 0",
                      display: "inline-block",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxSizing: "border-box",
                      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  {errors.password && (
                    <p style={{ color: "red" }}>{errors.password.message}</p>
                  )}
                </div>

                <div className="mb-6">
                  <label className="flex items-center">
                    <input type="checkbox" {...register("rememberMe")} />
                    Remember Me
                  </label>
                </div>

                <div className="text-center lg:text-left">
                  {loading ? (
                    <div>Loading...</div>
                  ) : (
                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#007bff",
                        color: "white",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "4px",
                        fontSize: "16px",
                        cursor: "pointer",
                        boxShadow: "0px 2px 2px 0px rgba(0,0,0,0.2)",
                        transition: "0.3s",
                        display: "inline-block",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    >
                      Login
                    </button>
                  )}
                </div>
                {loginError && <p style={{ color: "red" }}>{loginError}</p>}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Signin;
